import { driveTimeFilter } from '../featureFlags'
import useFeatureFlag from '../hooks/useFeatureFlag'
import useReduxSelector from '../hooks/useReduxSelector'
import { useDriveTimeFilterQuery } from '../hooks/useQueries'

type DriveTimeFilterState = {
  available: boolean
  originCityName?: string | null
  /** False while eligibility is still being fetched — unknown, not ineligible */
  resolved: boolean
}

// Deliberately a separate client-only query: eligibility is viewer-dependent,
// so it must stay out of the SSR-seeded search document.
const useDriveTimeFilterAvailable = (
  filters: GQL_SearchFilters,
): DriveTimeFilterState => {
  const flagEnabled = useFeatureFlag(driveTimeFilter)
  // Per-actor flags arrive via an async /features fetch after mount; until it
  // settles, "flag off" is indistinguishable from "unknown" and must not read
  // as resolved or the exposure marker records eligible visitors as ineligible.
  const flagsSettled = useReduxSelector(
    (state) => state.featureFlags.fetched || state.featureFlags.error != null,
  )
  const { data, error } = useDriveTimeFilterQuery({
    variables: { country: filters.country, state: filters.state },
    skip: !flagEnabled,
  })

  return {
    available: Boolean(data?.driveTimeFilter?.available),
    originCityName: data?.driveTimeFilter?.originCityName,
    resolved:
      flagsSettled &&
      (!flagEnabled || data !== undefined || error !== undefined),
  }
}

export default useDriveTimeFilterAvailable
